<template>
    <div class="parametric-sidebar">
        <div ref="parametricSidebarTop"
             class="parametric-sidebar__top">
            <div class="parametric-sidebar__top-title">Выбранное</div>
            <div class="parametric-sidebar__top-info">
                <div class="parametric-sidebar__top-info-count">
                    <template v-if="flats?.length">
                        Выбрано {{ flats.length }} {{ pluralFlats }}
                    </template>
                    <template v-else>Ничего не выбрано</template>
                </div>
                <STBaseButton v-if="flats?.length"
                              modify="button_theme_reset"
                              text="Очистить список"
                              @click="removeAll" />
            </div>
        </div>

        <div v-if="flats?.length"
             class="parametric-sidebar__content">
            <div class="parametric-sidebar__flats"
                 :style="{'max-height': maxHeightContent}">
                <div v-for="project in computedFlats"
                     :key="project.complex"
                     class="parametric-sidebar__project">
                    <div class="parametric-sidebar__project-header">
                        <div class="parametric-sidebar__project-title">
                            {{ project.complex }}
                        </div>
                        <a v-if="project.flats[0]?.site"
                           :href="project.flats[0]?.site"
                           class="parametric-sidebar__project-link"
                           target="_blank">
                            {{ project.flats[0]?.site | clearLink }}
                        </a>
                    </div>
                    <ParametricSidebarFlat
                        v-for="flat in project.flats"
                        :key="flat.id"
                        :flat-data="flat" />
                </div>
            </div>
        </div>

        <div ref="parametricSidebarActions"
             class="parametric-sidebar__actions">
            <div v-if="errorMessage"
                 class="parametric-sidebar__alert"
                 v-html="errorMessage" />

            <STBaseButton modify="parametric-sidebar__action button_size_small button_full_width"
                          text="Отправить на почту"
                          :disabled="Boolean(!flats?.length || errorMessage.length)"
                          @click="$emit('showSendPopup', 'email')" />

            <STBaseButton modify="parametric-sidebar__action button_size_small button_full_width button_theme_white"
                          icon-before="IconDownload"
                          icon-before-modify="icon-stroke icon_color_blue"
                          text="Скачать на устройство"
                          :disabled="Boolean(!flats?.length || errorMessage.length)"
                          @click="$emit('showSendPopup', 'download')" />
        </div>
    </div>
</template>

<script>
import ParametricSidebarFlat from '@/blocks/ParametricBlock/ParametricSidebar/ParametricSidebarFlat';
import {mapActions, mapGetters} from 'vuex';
import Utils from '@/helpers/Utils';

/**
 * Компонент сайдбара для параметрического выборщика
 */
export default {
    name: 'ParametricSidebar',

    components: {
        ParametricSidebarFlat
    },

    filters: {
        clearLink: (url) => {
            // Удаляем "http://" или "https://" из начала строки
            url = url.replace(/^https?:\/\//i, '');

            // Удаляем завершающий символ "/", если он есть
            url = url.replace(/\/$/, '');

            return url;
        },
    },

    data() {
        return {
            maxHeightContent: 'none' // максимальная высота контента с помещениями
        };
    },

    computed: {
        ...mapGetters({
            flats: 'parametric/GET_PRINT_FLATS' // массив помещений для печати
        }),

        /**
         * Количество выбранных помещений для печати
         * @return {number}
         */
        selectedCount() {
            return this.flats.length;
        },

        /**
         * Окончание слова для помещений
         * @return {string}
         */
        pluralFlats() {
            if (!this.flats?.length) {
                return 'объектов';
            }

            return Utils.pluralWord(this.flats.length, ['объект', 'объекта', 'объектов']);
        },

        /**
         * Сообщении ошибки
         * @return {string}
         */
        errorMessage() {
            const limitError = this.flats?.length > 10;

            if (!limitError) {
                return '';
            }

            return 'Ошибка!<br/>Вы не можете добавлять более 10 планировок';
        },

        computedFlats() {
            const selectedProjects = this.flats.map((item) => item.complex);
            const uniqueProjects = [...new Set(selectedProjects)];
            let result = [];

            uniqueProjects.forEach((project) => {
                result.push({
                    complex: project,
                    flats  : this.flats.filter((item) => item.complex === project)
                });
            });

            return result;
        }
    },

    watch: {
        /**
         * При изменении кол-ва выбранных элементов
         * изменяем максимальную высоту контента
         */
        selectedCount() {
            this.$nextTick(() => {
                const topHeight = this.$refs?.parametricSidebarTop ? this.$refs.parametricSidebarTop.offsetHeight : 0;
                const actionsHeight = this.$refs?.parametricSidebarActions ? this.$refs.parametricSidebarActions.offsetHeight : 0;
                const headerHeight = Utils.isMobile() ? 0 : 70;

                this.maxHeightContent = `calc(100vh - ${topHeight + actionsHeight + headerHeight}px)`;
            });
        }
    },

    methods: {
        ...mapActions('parametric', ['removeAllFlatsFromPrint']),

        /**
         * Удаляет все помещения из печати
         */
        removeAll() {
            this.removeAllFlatsFromPrint();
        }
    }
};
</script>

<style lang="scss">
@import "ParametricSidebar";
</style>
